import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import type React from 'react'
import { FC } from 'react'
import Text from 'core/elements/Text'
import type Theme from 'core/themes/model'

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  container: {
    display: 'grid',
    gridTemplateColumns: 'max-content auto',
    gap: 16,
    alignItems: 'center',
  },
  circle: {
    color: theme.palette.grey['000'],
    // color: theme.components.card.passiveText,
    background: theme.palette.blue[500],
    // background: theme.components.badge.unknown.background,
    // border: `1px solid ${theme.components.card.border}`,
    width: 24,
    height: 24,
    borderRadius: 12,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  greyCircle: {
    color: `${theme.palette.grey[600]} !important`,
    background: theme.palette.grey[100],
    border: `1px solid ${theme.palette.grey[200]}`,
  },
}))

interface Props {
  step: number
  title: string | React.ReactNode
  className?: string
  bold?: boolean
  greyscale?: boolean
}

export default function NumberedStepLabel({
  step,
  title,
  className,
  bold = true,
  greyscale = false,
}: Props) {
  const classes = useStyles()
  return (
    <div className={clsx(classes.container, className)}>
      <Text variant="caption1" className={clsx(classes.circle, greyscale && classes.greyCircle)}>
        {step}
      </Text>
      <Text className="title" variant={bold ? 'caption1' : 'body2'}>
        {title}
      </Text>
    </div>
  )
}
